import styled from 'styled-components';
import OrderSummary from './OrderSummary';

export default styled(OrderSummary)`
  margin: 0;
  padding: 0;
`;
